import { render, staticRenderFns } from "./PartnerName.vue?vue&type=template&id=f441131c&"
import script from "./PartnerName.vue?vue&type=script&lang=ts&"
export * from "./PartnerName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports